<template>
    <div class="">

        <modal-default ref="modalNotConfirmed" size="large" active-back-drop show-footer fixed-height
                       title="NOT CONFIRMED EVENTS"
                       @close="() => { staffData = ''}">

            <form>
                <div class="form-row">
                    <div class="col-md-3 mb-3">
                        <label for="startDate">Initial Date</label>
                        <input v-model="filter.initialDate" type="date" class="form-control" id="startDate">
                    </div>
                    <div class="col-md-3 mb-3">
                        <label for="endDate">Final Date</label>
                        <input v-model="filter.finalDate" type="date" class="form-control" id="endDate">
                    </div>
                    <div class="col-md-3 mb-3">
                        <label for="userSelect">Creator By</label>
                        <select-component
                            @selected="(val) => filter.creator =  val"
                            name="creator"
                            url-search="/users/list-of-choices"
                            url-show="/users/list-of-choices"
                            :initial-value="0">
                        </select-component>
                    </div>
                    <div class="col-md-3 mb-3">
                        <div style="width: 100%; height: 20px;">&nbsp;</div>
                        <button class="btn btn-primary" style="" type="button" @click="getDataCalendar">Search</button>

                    </div>
                </div>
            </form>


            <table class="table">
                <tr>
                    <td width="10px"></td>
                    <th style="width: 30%">Event</th>
                    <th>Dt. Start</th>
                    <th>Dt. End</th>
                    <th>Creator By</th>
                </tr>
                <tr v-if="loading">
                    <th colspan="4"> Loading events (NOT CONFIRMED) ...</th>
                </tr>
                <slot v-for="(events, index) in schedules">
                    <tr>
                        <td colspan="5">
                            <a href="#" data-toggle="collapse" :data-target="'#' + createSlug(index)" class="show">
                              <i class="fa fa-chevron-down"></i>  <strong>{{ index }}</strong>
                            </a>
                        </td>
                    </tr>
                    <tr :id="createSlug(index)" v-for="event in events" class="collapse show">
                        <td></td>
                        <td>
                        <span class="badge" style="width: 100%; cursor: pointer;" @click="openEvent(event.id)"
                              :style="{backgroundColor:event.backgroundColor, color:event.textColor, borderColor:event.borderColor}">{{
                                event.title
                            }}</span>
                        </td>
                        <td>{{ event.start | dateUs }}</td>
                        <td>{{ event.end | dateUs }}</td>
                        <td>{{ event.creator }}</td>
                    </tr>
                </slot>

            </table>
        </modal-default>
    </div>
</template>

<script>
import Modal from "../../history/Modal.vue";
import ModalDefault from "../../generics/ModalDefault.vue";

export default {
    name: 'ScheduleNotConfirmed',
    components: {ModalDefault, Modal},
    data() {
        return {
            schedules: [],
            staff_id: 275,
            startDate: null,
            endDate: null,
            loading: false,
            filter: {
                initialDate: null,
                finalDate: null,
                creator: null,
            }
        }
    },

    mounted() {
        if (!this.filter.initialDate) {
            const oneYearAgo = new Date();
            oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
            this.filter.initialDate = this.formatDate(oneYearAgo);
        }
        if (!this.filter.finalDate) {
            const today = new Date();
            this.filter.finalDate = this.formatDate(today);
        }
        this.getDataCalendar();
        this.$forceUpdate()

    },

    methods: {
        getEvents() {
            this.$refs.modalNotConfirmed.show()
        },

        openEvent(id) {
            popupwindow('/schedules' + '/iframe/' + id);
        },

        getDataCalendar() {
            this.loading = true;

            this.startDate = this.filter.initialDate
            this.endDate = this.filter.finalDate

            axios.post('/schedules/callendar-data', {
                startWeek: this.startDate, endWeek: this.endDate,
                staff_id: this.staff_id,
                creator: this.filter.creator
            }).then((e) => {
                this.schedules = this.groupBy(e.data.data.resources, 'creator')
            }).finally((e) => this.loading = false)
        },
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        groupBy(arr, key) {
            return arr.reduce((result, item) => {
                const keyValue = item[key];

                if (!result[keyValue]) {
                    result[keyValue] = [];
                }

                result[keyValue].push(item);

                return result;
            }, {});
        },
        createSlug(str) {
            const slug = str.toLowerCase().replace(/\s+/g, '-');

            const cleanSlug = slug.replace(/[^\w-]/g, '');

            const finalSlug = cleanSlug.replace(/-{2,}/g, '-');

            return finalSlug.replace(/^-+|-+$/g, '');
        },
        toggleButtons(targetId) {
            const target = document.getElementById(targetId);
            const openButton = document.querySelector(`[data-target="#${targetId}"][class="btn btn-primary"]`);
            const closeButton = document.querySelector(`[data-target="#${targetId}"][class="btn btn-danger"]`);

            if (target.style.display === 'none' || target.style.display === '') {
                openButton.style.display = 'none';
                closeButton.style.display = 'block';
            } else {
                openButton.style.display = 'block';
                closeButton.style.display = 'none';
            }
        }



    }
}
</script>
<style scoped>

</style>
